<script lang="ts">
	import type { PageData } from './$types';
	import { page } from '$app/state';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import FiltersPanel from '$lib/components/pois/filters/FiltersPanel.svelte';
	import { getSearchParamsStore, gotoWithParams } from '$lib/services/urls/searchParams';

	const {
		poiMarkerWithDetailsEnabled,
		onAccommodationSelectDates,
		onAccommodationClearDates,
		onMichelinSelectionChange,
		handlePoiMarkerWithDetailsByFilterChange,
	} = getMapLayoutContext();

	const searchParams = getSearchParamsStore();

	interface Props {
		data: PageData;
	}

	const { data }: Props = $props();
	const { partnersLinks } = $derived(data);
</script>

<FiltersPanel
	{partnersLinks}
	withPartner={page.data.hasPartnerAdinmap}
	detailedView={$poiMarkerWithDetailsEnabled}
	on:goBack={() => {
		// DO NOT USE goBackWithFallback here because we want the filters to persist
		gotoWithParams('/map', $searchParams);
	}}
	on:selectDates={({ detail }) => {
		onAccommodationSelectDates(detail);
	}}
	on:clearDates={() => {
		onAccommodationClearDates();
	}}
	on:michelinSelectionChange={({ detail: isOnlyMichelin }) => {
		onMichelinSelectionChange(isOnlyMichelin);
	}}
	on:poiFilterChange={handlePoiMarkerWithDetailsByFilterChange}
/>
